
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jXHGs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6e9c56f561346e28$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $6e9c56f561346e28$export$2e2bcd8739ae039 = {
    'editorExtensionLinkCreate.confluencePage.newDraftTitle': 'Sida utan rubrik',
    'editorExtensionLinkCreate.confluencePage.quickInsert.description': "Skapa en ny sida och infoga den som en l\xe4nk",
    'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Skapa Confluence-sida',
    'editorExtensionLinkCreate.confluencePage.successFlag.action.open': "\xd6ppna i Confluence",
    'editorExtensionLinkCreate.confluencePage.successFlag.description': 'Din sida har skapats',
    'editorExtensionLinkCreate.confluencePage.successFlag.title': 'Sidan har skapats',
    'editorExtensionLinkCreate.confluencePage.title': 'Skapa en ny sida',
    'editorExtensionLinkCreate.genericError.description': "Uppdatera sidan och f\xf6rs\xf6k igen.",
    'editorExtensionLinkCreate.genericError.title': "N\xe5got gick fel",
    'editorExtensionLinkCreate.jiraIssue.quickInsert.description': "Skapa ett inline-\xe4rende och infoga \xe4rendet som en l\xe4nk",
    'editorExtensionLinkCreate.jiraIssue.quickInsert.title': "Skapa Jira-\xe4rende",
    'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': "\xd6ppna i Jira",
    'editorExtensionLinkCreate.jiraIssue.successFlag.description': "Ditt \xe4rende har skapats",
    'editorExtensionLinkCreate.jiraIssue.successFlag.title': "\xc4rendet har skapats",
    'editorExtensionLinkCreate.jiraIssue.title': "Skapa nytt \xe4rende",
    'editorExtensionLinkCreate.keyword.create': 'skapa',
    'editorExtensionLinkCreate.keyword.issue': "\xe4rende",
    'editorExtensionLinkCreate.keyword.new': 'ny',
    'editorExtensionLinkCreate.keyword.page': 'sida',
    'editorExtensionLinkCreate.keyword.publish': 'publicera',
    'editorExtensionLinkCreate.keyword.raise': "\xf6ppna",
    'editorExtensionLinkCreate.keyword.space': 'utrymme',
    'editorExtensionLinkCreate.keyword.ticket': "\xe4rende"
};

});


//# sourceMappingURL=sv.5e2b9d2a.js.map
